import type { RouteRecordRaw } from 'vue-router';

import { usePromoteStore } from '@/views/dashboard/promote/promote.store';
import { routes as zoneRoutes } from './zone/zone.routes';

export const routes: RouteRecordRaw = {
  name: 'dashboard',
  path: '/',
  component: () => import('#/dashboard/dashboard.view.vue'),
  children: [
    {
      name: 'home',
      path: '',
      component: () => import('#/dashboard/home/home.view.vue'),
    },
    {
      name: 'promote',
      path: 'promote',
      // Any authenticated user can store a geometry (the backend enforces
      // project access). Only guard against a direct visit / refresh with no
      // drawing stashed by the Draw tool — bounce those home before mount.
      beforeEnter: (_to, _from, next) => (usePromoteStore().draft ? next() : next('/')),
      component: () => import('#/dashboard/promote/promote.view.vue'),
    },
    {
      name: 'change-log',
      path: 'change-log',
      component: () => import('#/dashboard/change-log/change-log.view.vue'),
    },
    {
      name: 'settings',
      path: 'settings',
      component: () => import('#/dashboard/settings/settings.view.vue'),
    },
    ...zoneRoutes,
  ],
};
